import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as c3 from 'c3';
const COLORSLISt = [
  '#515CB4', '#D26999', '#72A8D5', '#82C7C2', '#7FE593',
  '#8F82C7', '#BF82C7', '#D27969', '#FDBF6F', '#FD8A6F',
  '#00A19D', '#FFB344', '#E05D5D', '#2D2424', '#52006A'
];
@Component({
  selector: 'app-da-rm-pm-popup-view',
  templateUrl: './da-rm-pm-popup-view.component.html',
  styleUrls: ['./da-rm-pm-popup-view.component.scss']
})
export class DaRmPmPopupViewComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('donutDiv') donutDiv: ElementRef;

  searchRmPmKeyword = '';
  searchRmPmPlaceHolder = 'Search for RM';
  selectedMaterialType = 'rm';
  costContributionRmPmItems: Array<any> = [];
  // graphColorRmPmObj = {};
  graphData: Array<any> = [];
  hoveredPerc = '';
  hoveredTitle = '';
  hoveredCost = '';
  filteredCostContributionRmPmItems: Array<any> = [];
  pmTotal = 1;
  rmTotal = 1;
  modifyedPmData = [];
  modifyedRmData = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
  ) { }


  ngOnInit() {
    this.selectedMaterialType = this.data.selectedType;
    /* istanbul ignore next */
    if (this.selectedMaterialType) {
      this.searchRmPmPlaceHolder = 'Search for ' + this.selectedMaterialType ? this.selectedMaterialType.toUpperCase() : '';
    }

  }

  /* istanbul ignore next */
  ngAfterViewInit() {
    if (this.data.responseData.materialGroupCostConsumption) {
    this.pmTotal = this.data.responseData.materialGroupCostConsumption.filter(pmTot =>
      pmTot.materialType.toLowerCase() === 'pm').map(item =>
        item.wasteCostEuro).reduce((prev, curr) => prev + curr, 0);

    this.rmTotal = this.data.responseData.materialGroupCostConsumption.filter(pmTot =>
      pmTot.materialType.toLowerCase() === 'rm').map(item =>
        item.wasteCostEuro).reduce((prev, curr) => prev + curr, 0);

    this.modifyedPmData = this.data.responseData.materialGroupCostConsumption.map((item, index) => {
      return {
        id: item.materialGroup,
        name: item.materialGroup,
        percentage: /* istanbul ignore next */ Math.abs(this.pmTotal) == 0 ? Number(Math.round((item.wasteCostEuro / 1) * 100)) : Number(Math.round((item.wasteCostEuro / Math.abs(this.pmTotal)) * 100)),
        cost: item.wasteCostEuro,
        type: item.materialType
      };
    });

    this.modifyedRmData = this.data.responseData.materialGroupCostConsumption.map((item, index) => {
      return {
        id: item.materialGroup,
        name: item.materialGroup,
        percentage: /* istanbul ignore next */ Math.abs(this.rmTotal) == 0 ? Number(Math.round((item.wasteCostEuro / 1) * 100)) : Number(Math.round((item.wasteCostEuro / Math.abs(this.rmTotal)) * 100)),
        cost: item.wasteCostEuro,
        type: item.materialType
      };
    });
  }

    if (this.selectedMaterialType.toLowerCase() === 'pm') {
      this.filterGraphData(this.modifyedPmData);
    } else {
      this.filterGraphData(this.modifyedRmData);
    }
  }


  ngAfterViewChecked() {
    /* istanbul ignore next */
    this.cdr.detectChanges();

  }

  /* istanbul ignore next */
  filterGraphData(modifyedData) {

    this.costContributionRmPmItems = [];

    // modifyedData.forEach((item, index) => {
    //   item.color = (index <= COLORSLISt.length) ? COLORSLISt[index] : this.getRandomColor();
    // });

    this.costContributionRmPmItems.push(...modifyedData);

    this.costContributionRmPmItems.sort((a, b) => {
      return a.percentage === b.percentage ? 0 : a.percentage < b.percentage ? 1 : -1;
    });

    // let duplicateCount = 1;
    // this.graphColorRmPmObj = this.costContributionRmPmItems.reduce((acc, item) => {
    //   if (acc[item.name]) {
    //     acc[item.name + duplicateCount] = item.color;
    //     duplicateCount++;
    //   }
    //   acc[item.name] = item.color;
    //   return acc;
    // }, {});
    this.graphData = this.costContributionRmPmItems.filter(dataRmPm =>
      dataRmPm.type.toLowerCase() === this.selectedMaterialType.toLowerCase()).reduce((acc, item) => {
        acc.push([item.name, item.percentage]);
        return acc;
      }, []);
    this.filteredCostContributionRmPmItems = [...this.costContributionRmPmItems.filter(dataValue =>
      dataValue.type.toLowerCase() === this.selectedMaterialType.toLowerCase())];

    this.drawDonut();
  }

  // getRandomColor() {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // }

  drawDonut() {
    c3.generate({
      bindto: this.donutDiv.nativeElement,
      size: {
        height: 300,
        width: 300
      },
      data: {
        columns: this.graphData || [],
        type: 'donut',
        // colors: this.graphColorRmPmObj || {}
      },
      donut: {
        title: '',
        width: 25,
        label: {
          show: false
        },
        expand: true,
      },
      legend: {
        hide: true
      },
      tooltip: {
        format: {
          value(value, ratio, id) {
            return `${value}%`;
          }
        }
      }
    });

  }
  
  /* istanbul ignore next */
  toggleType(type: string) {
    this.selectedMaterialType = type;
    this.searchRmPmPlaceHolder = 'Search for ' + this.selectedMaterialType ? this.selectedMaterialType.toUpperCase() : '';
    this.searchRmPmKeyword = '';
    if (this.selectedMaterialType.toLowerCase() === 'pm') {
      this.filterGraphData(this.modifyedPmData);
    } else {
      this.filterGraphData(this.modifyedRmData);
    }
  }

  /* istanbul ignore next */
  searchRmOrPm(keyword: string): void {

    if (keyword && keyword !== '') {
      this.searchRmPmKeyword = keyword;

      const clonedList = [...this.costContributionRmPmItems.filter(dataValueLi =>
        dataValueLi.type.toLowerCase() === this.selectedMaterialType.toLowerCase())];

      this.filteredCostContributionRmPmItems = clonedList.filter(clonedItem => {
        return clonedItem.name.toLowerCase().includes(keyword.toLowerCase());
      });

    } else {
      this.filteredCostContributionRmPmItems = [...this.costContributionRmPmItems.filter(dataValueList =>
        dataValueList.type.toLowerCase() === this.selectedMaterialType.toLowerCase())];
    }
  }
}
